import storage from 'store';
import { login } from '@/api/login';
import { getUserInfo } from '@/api/user';

const ACCESS_TOKEN = 'ACCESS_TOKEN';
const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, userInfo) => {
      if (userInfo) {
        state.info = userInfo;
      }
    },
  },
  actions: {
    // 登录
    async login({ commit }, userInfo) {
      const res = await login({ ...userInfo });
      if (res.code === 0) {
        commit('SET_TOKEN', res.data.token);
        storage.set(ACCESS_TOKEN, res.data.token, res.data.expires);
        return { success: true };
      }
      return {
        success: false,
        errCode: res.code,
        errMessage: res.message,
      };
    },
    // 获取当前用户信息
    async getCurUserInfo({ commit }) {
      const res = await getUserInfo();
      commit('SET_USERINFO', res.data);
    },
  },
};
export default user;
